import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree, projectFour, projectFive } from "../../assets/index";
import ProjectsCard from './ProjectsCard';


const Projects = () => {
  


  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="ROOTSTORY"
          des=" On this platform, users can create, edit, publish
          or delete stories between them, choosing between a status
          private or public, and using anonymous or signed mentions to
          interact."
          src={projectOne}
          githubUrl="https://github.com/MadeusRootchy/yonSitIstwa.git"
          hostLink="https://yon-sit-istwa.vercel.app/"
          
        />
        <ProjectsCard
          title="WORLD COUNTRIES"
          des=" here you will find detailed information on all countries in the world!"
          src={projectTwo}
          hostLink="https://world-countries-data-wcd.vercel.app/"
          githubUrl="https://github.com/roosjjean/world-countries-data-wcd.git"

        />
        <ProjectsCard
          title="CONTACT BOOK"
          des=" This is a program developed in Python with Django which
          allows you to list contacts and perform all actions
          common contact-related routines, such as registration,
          editing, deleting, listing and searching by name.!"
          src={projectThree}
          hostLink="https://github.com/MadeusRootchy/Django-constact-book.git"
          githubUrl="https://github.com/MadeusRootchy/Django-constact-book.git"
        />
         <ProjectsCard
          title="STACKOVERFLOW"
          des=" Ce projet simule en gros les fonctionnalites de bases de la
          platforme StackOverFlow et permet aussi le partage de code en
          utilisant React JS."
          src={projectFour}
          hostLink="https://github.com/MadeusRootchy/stackOverFlow"
          githubUrl="https://github.com/MadeusRootchy/stackOverFlow"
        /> 
          <ProjectsCard
          title="BLOG POST"
          des=" This code creates a simple user interface for displaying blog
           posts, allowing the user to choose how many posts to display and to 
           reset the display."
          src={projectFive}
          hostLink="https://github.com/MadeusRootchy/blog"
          githubUrl="https://github.com/MadeusRootchy/blog"
        />
        
      </div>
    </section>
  );
}

export default Projects